class MenuHover {
    constructor() {
        this.body = document.querySelector('body')
        this.touch = null
        this.events()


    }

    debounce (func, wait, immediate) {
        var timeout;
        return () => {
            const context = this, args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        }
    }
    events() {
        this.checkTouch()
        this.bindMouseenter ()
        this.bindBody ()
        var that = this


        window.addEventListener('resize', that.debounce(() => {
                console.log('-- debounce -')
                that.checkTouch()
        } , 200, false), false);
    }
    checkTouch() {
        if (!("ontouchstart" in document.documentElement)) {
            console.log ("no-touch")
            this.body.classList.remove('has-touch')
            this.body.classList.add('no-touch')
            this.touch = false
        }else {
            console.log ("has-touch")
            this.touch = true
            this.body.classList.remove('no-touch')
            this.body.classList.add('has-touch')
        }
    }



    bindMouseenter () {
        var that = this
        // const items = document.querySelectorAll( ".menu-item-has-children")
        const items = document.querySelectorAll( ".menu-item")
        for (var z = 0; z < items.length; z++) {

            items[z].addEventListener("click", function (event) {
                that.checkTouch()
                var cList = this.classList;
                let href = event.target.dataset.href
               /* console.log ( href );
                console.log ( cList );
                console.log (  that.touch );*/

              /*
               scenario
               touch => true || false
               has-mouseenter
               is-active-submenu
               menu-item-has-children
              */

            // cList.contains("has-mouseenter")
                let noToucIsActiveSubmenuHasChild = cList.contains('has-mouseenter')
                                                    && !that.touch
                                                    && cList.contains("menu-item-has-children")

                let  noChildrenIsActiveSubmenu = !cList.contains("menu-item-has-children")
                                                    || cList.contains("is-active-submenu")


                if ( noToucIsActiveSubmenuHasChild || noChildrenIsActiveSubmenu) {
                    //debugger
                    window.location.href = href
                }else {

                    if ( !cList.contains('menu-item--active') && cList.contains('is-active-submenu') ) {

                        window.location.href = href
                    }
                    if (cList.contains('is-active-submenu')
                        && cList.contains('menu-item-has-children')
                        && cList.contains('menu-item--active')
                    ){
                        that.closeTargets()
                    } else {
                        cList.add('is-active-submenu')
                    }
                }
            })
            items[z].addEventListener("mouseenter", function (event) {
                event.preventDefault()
                that.closeTargets()
                if ( this.classList.contains("menu-item-has-children") ) {
                    console.log("addEventListener mouseenter")
                    this.classList.add('has-mouseenter')
                }
            })
        }
    }
    bindBody (){
        var that = this

        if (this.body){
            const ie_version = this.detectIE()
            this.body.addEventListener("mouseover", function (event) {


                if (!ie_version || ie_version >= 12) {
                    var closest = event.target.closest('.js-menu')
                    if (closest != null){
                        return false
                    }
                    that.closeTargets()
                }
                if (ie_version && ie_version < 12) {
                    // close sub ie 11
                    var listItem = null
                    if (event.target == null) {
                        that.closeTargets()
                    }
                    if (event.target != null) {
                        for (var node = event.target; node != null; node = node.parentNode) {
                            if (node.classList === undefined) {
                            } else if (node.classList.contains("js-menu")) {
                                listItem = node
                                break
                            }
                        }
                    }
                    if (listItem == null) {
                        that.closeTargets()
                    }
                }
            })
        }
    }


    closeTargets() {
        var aTarget = document.querySelector('.menu-item-has-children.is-active-submenu')
        if (aTarget != null){
            aTarget.classList.remove('is-active-submenu')
        }
        var bTarget = document.querySelector('.menu-item-has-children.has-mouseenter')
        if (bTarget != null){
            bTarget.classList.remove('has-mouseenter')
        }
    }


    detectIE() {
        var ua = window.navigator.userAgent
        var msie = ua.indexOf('MSIE ')
        if (msie > 0) {return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)}
        var trident = ua.indexOf('Trident/')
        if (trident > 0) {
            var rv = ua.indexOf('rv:')
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
        }
        var edge = ua.indexOf('Edge/')
        if (edge > 0) {return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)}
        return false
    }

}

export default MenuHover


